<!-- image -->
<skeleton-rect [ratio]="ratio()" />
<!-- name -->
@if (!banner()) {
<div class="p-t-1 _name">
    <skeleton-rect [style.margin-top.px]="3"
                   [height]="'18px'" />
    <skeleton-rect [style.margin-top.px]="3"
                   [width]="'50%'"
                   [height]="'18px'" />
    <skeleton-rect [style.margin-top.px]="6"
                   [height]="'18px'"
                   [width]="'50px'" />
</div>
}